/**
 * Filtros da Gaveta de NFs do Kanban de Compras. O recorte que define a gaveta — nota de entrada
 * sem pedido vinculado — é regra do endpoint e não trafega aqui.
 */
export class NotaFiscalEntradaGavetaListarRequest {
  listIdPessoaEmitente: number[] | null;
  pesquisar: string | null;
  dataDe: Date | null;
  dataAte: Date | null;
  /**
   * Modo sugestão (seletor de NF do pedido): notas do emitente OU com algum dos produtos, com a
   * `faixaSugestao` preenchida e já ordenadas por faixa. Nulos fora desse modo.
   */
  idPessoaEmitenteSugestao: number | null = null;
  listIdProdutoSugestao: number[] | null = null;
}
